import type { CompanyValue } from "@/types/about.types";

export const COMPANY_VALUES: CompanyValue[] = [
  {
    id: "innovation",
    title: "Innovation",
    body:
      "We continuously challenge conventional thinking, encouraging our team to explore creative solutions that push technological boundaries. Our commitment to innovation means we're always seeking breakthrough approaches that transform challenges into opportunities.",
  },
  {
    id: "integrity",
    title: "Integrity",
    body:
      "We hold ourselves to the highest ethical standards in everything we do. Transparency, honesty, and accountability are at the core of every decision we make — with our clients, our partners, and each other.",
  },
  {
    id: "collaboration",
    title: "Collaboration",
    body:
      "Great ideas rarely emerge in isolation. We foster a culture where diverse perspectives come together, driving stronger outcomes through open communication, shared goals, and mutual respect across every team.",
  },
  {
    id: "excellence",
    title: "Excellence",
    body:
      "Good enough is never enough. We pursue mastery in our craft, setting ambitious benchmarks and holding ourselves accountable to delivering work that consistently exceeds expectations for our clients and community.",
  },
  {
    id: "customer",
    title: "Customer-Centricity",
    body:
      "Our customers are at the heart of every product decision, roadmap priority, and support interaction. We listen deeply, respond thoughtfully, and build solutions that solve real problems for real people.",
  },
  {
    id: "adaptability",
    title: "Adaptability",
    body:
      "The world moves fast and so do we. We embrace change as an opportunity rather than a threat, staying nimble and resilient so we can pivot quickly and continue delivering value no matter what the market brings.",
  },
];
